import React from 'react';
import { connect } from 'react-redux';
import Label from './SummaryLabel';
import Badge from './SummaryBadge';

function UploadSummary({
  nAll,
  nNew,
  nSkipped,
  nUpdated,
  nUpdateSkip,
  nUpdateEquiv,
  nEmpty,
}) {
  return (
    <div className="p-3 bg-lightgray border border-light mb-2">
      <Label />
      <div className="d-flex justify-content-center">
        <Badge label="New" n={nNew} color="info" />
        <Badge label="Updates" n={nUpdated - nUpdateEquiv} color="lightgreen" />
        <Badge label="No Change" n={nUpdateSkip + nUpdateEquiv + nSkipped} color="gray" />
        <Badge label="Empty" n={nEmpty} color="gray" />
        <Badge label="Total Rows" n={nAll} color="gray" />
      </div>
    </div>
  );
}

const mapStateToProps = (store) => ({
  nAll: store.batch.n_all_rows - 1,
  nNew: store.batch.n_new_rows,
  nSkipped: store.batch.n_skipped_rows,
  nUpdated: store.batch.n_updated_rows,
  nUpdateSkip: store.batch.n_updated_rows_no_value_change,
  nUpdateEquiv: store.batch.n_updated_but_equivalent,
  nEmpty: store.batch.n_empty_rows,
});

export default connect(mapStateToProps)(UploadSummary);
